export default {
  namespaced: true,
  providers: {
    title: "Provedores"
  }
}
